import {
  WSActions,
  WSCard,
  WSDataItem,
  WSElement,
  WSForm,
  WSInputDate,
  WSInputText,
  WSList,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { useWSMutation } from "@ws-react-query";
import {
  FormDataAddress,
  FormPartialAddress
} from "../../../Onboarding/components/FormPartialAddress";
import { OnboardingStep } from "../../../Onboarding/types";
import { useUserId } from "../../../../query/hooks/helpers";
import { useQueryCustomerEntity } from "../../../../query/onboarding/queries/useQueryCustomerEntity";
import {
  useMemberProfile,
  useUserProfile
} from "../../../../query/users/queries";
import { entityDataService } from "../../../../shared/services/entityData";
import { WSServiceError } from "../../../../utils/serviceHelper";

type FormData = {
  firstName: string;
  lastName: string;
  dob: Date;
  address: FormDataAddress;
};

export const StepInformation: React.FC<OnboardingStep> = props => {
  const userId = useUserId();
  const queryCustomerEntity = useQueryCustomerEntity();
  const queryUser = useUserProfile(userId);
  const queryMember = useMemberProfile(userId);

  const [mutate, meta] = useWSMutation<void, WSServiceError, FormData>(
    async data => {
      await entityDataService.updateEntity(
        {
          firstName: data.firstName,
          lastName: data.lastName,
          dateOfBirth: data.dob,
          address: data.address
        },
        {
          userId
        }
      );
    },
    {
      onSuccess: props.onNext
    }
  );

  return (
    <WSForm<FormData>
      defaultValues={{
        firstName: queryUser.data?.profile.firstName,
        lastName: queryUser.data?.profile.lastName,
        dob: queryUser.data?.profile.dob,
        address: queryMember.data?.profile.address
      }}
      onSubmit={values => {
        mutate(values);
      }}
    >
      <WSList gap="2XL">
        <WSElement>
          <WSSectionToolbar title="Confirm your information" />
          <WSText.ParagraphSm color="gray500">
            Confirm your information to enroll in Premium Perks and receive your
            welcome packet.
          </WSText.ParagraphSm>
        </WSElement>

        <WSCard>
          <WSList gap="L">
            <WSDataItem label="Email" value={queryUser.data?.email} />

            <WSList gap="XL" kind="Horizontal" equalItems>
              <WSForm.Field
                name="firstName"
                label="First name"
                component={WSInputText}
                componentProps={{
                  required: true,
                  disabled: !!queryCustomerEntity.data
                }}
              />
              <WSForm.Field
                name="lastName"
                label="Last name"
                component={WSInputText}
                componentProps={{
                  required: true,
                  disabled: !!queryCustomerEntity.data
                }}
              />
            </WSList>

            <WSForm.Field
              name="dob"
              label="Date of birth"
              component={WSInputDate}
              componentProps={{
                required: true,
                disabled: !!queryCustomerEntity.data
              }}
            />
          </WSList>
        </WSCard>

        <WSCard header="Address">
          <FormPartialAddress country="US" name="address" />
        </WSCard>

        <WSActions
          alignment="fill"
          buttons={[
            {
              label: "Continue to payment",
              loading: meta.isLoading
            }
          ]}
        />
      </WSList>
    </WSForm>
  );
};
